import { Link as RouterLink } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box, Fade, Grid, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

import LeftMenuNavComponent from './MenuComponent';

import { drawerClosedWidth, drawerOpenedWidth } from '../../staticData';
import { getMenuData } from './LeftMenuItems';

const ignoredProps = ['isDrawerOpen'];

const StyledDrawer = styled(Grid, {
  shouldForwardProp: (prop) => !ignoredProps.includes(prop),
})(({ theme, isDrawerOpen }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  flexWrap: 'nowrap',
  width: drawerOpenedWidth,
  height: '100%',
  position: 'fixed',
  overflowY: 'auto',
  overflowX: 'hidden',
  backgroundColor: theme.palette.common.white,
  padding: '2rem 2rem 1rem 2rem',
  zIndex: theme.zIndex.appBar + 2,
  transition: theme.transitions.create(['width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(!isDrawerOpen && {
    width: drawerClosedWidth,
    padding: '0.5rem',
    transition: theme.transitions.create(['width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      width: 0,
      padding: 0,
    },
  }),
}));

const SideNavComponent = (props) => {
  const {
    isNavigationShown,
    isDrawerOpen,
    setDrawerOpen,
    isMobileScreen,
    navLogoUrl,
  } = props;

  const menu = isNavigationShown && getMenuData();

  if (!menu) return null;

  return (
    <StyledDrawer isDrawerOpen={isDrawerOpen} className="hide-scrollbar">
      {isDrawerOpen && (
        <Link component={RouterLink} to="/">
          <img
            style={{ overflow: 'hidden', width: '100%' }}
            src={navLogoUrl}
            alt="Carson Logo"
          />
        </Link>
      )}
      <LeftMenuNavComponent
        menuData={menu}
        isDrawerOpen={isDrawerOpen}
        setDrawerOpen={setDrawerOpen}
        isMobileScreen={isMobileScreen}
      />
      <Box sx={{ flexGrow: 1 }} />
      {isDrawerOpen && (
        <Fade
          in={isDrawerOpen}
          style={{ transitionDelay: isDrawerOpen ? '200ms' : '0ms' }}
        >
          <Link
            component={RouterLink}
            to="/support"
            color="primary"
            sx={{ alignSelf: 'center', padding: '1rem' }}
          >
            Carson Support
          </Link>
        </Fade>
      )}
    </StyledDrawer>
  );
};

SideNavComponent.propTypes = {
  setDrawerOpen: PropTypes.func.isRequired,
  isNavigationShown: PropTypes.bool.isRequired,
  navLogoUrl: PropTypes.string.isRequired,
  isMobileScreen: PropTypes.bool.isRequired,
  isDrawerOpen: PropTypes.bool.isRequired,
};

export default SideNavComponent;
